import LassoTool from 'diagram-js/lib/features/lasso-tool/LassoTool';
import {getEnclosedElements} from 'diagram-js/lib/util/Elements';
import {values} from 'lodash';
import {TreeNavigator} from "@ispm/shared/bpmn-io/services/tree-navigator";
import Selection from 'diagram-js/lib/features/selection/Selection';
import EventBus from "diagram-js/lib/core/EventBus";
import Canvas from "diagram-js/lib/core/Canvas";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {END_NODE_ID} from '@ispm-shared/modules/bpmn/diagram-element-terms';

export class CustomLassoTool extends LassoTool {

  constructor(private eventBus: EventBus, private canvas: Canvas, private dragging, private elementRegistry, private selection: Selection, private toolManager,private mouse, private treeNavigator: TreeNavigator) {
    super(eventBus, canvas, dragging, elementRegistry, selection, toolManager,mouse);
  }


  public select(elements, bbox) {
    const selectedElements = values(getEnclosedElements(elements, bbox));
    const filteredVisibleElements = selectedElements.filter(element => (!element.hidden && element.businessObject.neighborhoodID && element.businessObject.neighborhoodID === this.treeNavigator.currentLayer && !this.elementIsEndOrConnectionToEndNode(element)));
    this.selection.select(filteredVisibleElements);
  }

  private elementIsEndOrConnectionToEndNode(element){
      return element.id === END_NODE_ID || (ModelingUtil.isConnection(element) && ModelingUtil.getConnectionTarget(element).id === END_NODE_ID);
  }
}

CustomLassoTool.$inject = [...LassoTool.$inject, 'treeNavigator'];

